import clone from 'lodash/cloneDeep';
import { data, data2 } from '../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY, BASE_INCOME } from './IncomeWorkflowConstants';
import * as PersonalInfoConstants from '../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';

const addEarnerIfNecessary = (baseIncome, earnerName) => {
  if (baseIncome.Earner === null) {
    return {
      ...baseIncome,
      Earner: earnerName,
    };
  }
  return baseIncome;
};

export const incomes = (state, props) => {
  const hasPartner = data2(state, props)(`${PersonalInfoConstants.BACKEND_KEY}.HasPartner`);
  const incomesArray = clone(data(state, props)(BACKEND_KEY) || []);
  let remainingToPush = 1 - incomesArray.length;
  while (remainingToPush > 0) {
    incomesArray.push(clone(BASE_INCOME));
    remainingToPush -= 1;
  }

  incomesArray[0] = addEarnerIfNecessary(
    incomesArray[0],
    data(state, props)(`${PersonalInfoConstants.BACKEND_KEY}.Principal.FirstName`),
  );

  if (hasPartner === true) {
    if (incomesArray.length < 2) {
      incomesArray.push(clone(BASE_INCOME));
    }
    incomesArray[1].IsSpouse = true;
    incomesArray[1] = addEarnerIfNecessary(
      incomesArray[1],
      data(state, props)(`${PersonalInfoConstants.BACKEND_KEY}.Partner.FirstName`),
    );
  }
  return incomesArray;
};
export const yearlySalary = (state, props) => incomes(state, props)[0].Amount;
export const partnerYearlySalary = (state, props) => {
  if (data2(state, props)(`${PersonalInfoConstants.BACKEND_KEY}.HasPartner`)) {
    return incomes(state, props)[1].Amount;
  }
  return null;
};
export const earner = (state, props) => incomes(state, props)[0].Earner;
export const earnerPartner = (state, props) => {
  if (data2(state, props)(`${PersonalInfoConstants.BACKEND_KEY}.HasPartner`)) {
    return incomes(state, props)[1].Earner;
  }
  return null;
};
